<!DOCTYPE html>
<html lang="en-US">
<head>
    <meta http-equiv="content-type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Navbar Right Align | Carey Development</title>
</head>

<body>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-light- bg1">
        <div class="container-fluid ">
            <div class="bg2">
                <a class="navbar-brand-" href="#">
                    <img src={{logoPath}} alt="logo" style="width: 100px;height: 100%;">
                </a>
            </div>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto position-static">
                    <!-- <li class="nav-item dropdown position-static">
                        <a class="nav-link dropdown-toggle-"  [routerLink]="['/aboutus-component']" routerLinkActive="router-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{aboutUs}}</a>
                        <div class="dropdown-menu dropdown-menu-center" aria-labelledby="navbarDropdown">
                            <a class="nav-link"  href="#home5">วิสัยทัศน์</a>
                            <a class="nav-link"  href="#home">ความเป็นมา</a>
                            <a class="nav-link"  href="#home2">พันธกิจ</a>
                            <a class="nav-link"  href="#home3">ค่านิยมองค์กร</a>
                            <a class="nav-link"  href="#home4">สารจากผู้ก่อตั้ง</a>
                        </div>
                    </li> -->

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle"  [routerLink]="['/aboutus-component']" routerLinkActive="router-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{aboutUs}}</a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <li><a class="nav-link"  href="#home5">วิสัยทัศน์</a></li>
                          <li><a class="nav-link"  href="#home">ความเป็นมา</a></li>
                          <li><a class="nav-link"  href="#home2">พันธกิจ</a></li>
                          <li><a class="nav-link"  href="#home3">ค่านิยมองค์กร</a></li>
                          <li><a class="nav-link"  href="#home4">สารจากผู้ก่อตั้ง</a></li>
                        </ul>
                      </li>


                    <li class="nav-item dropdown position-static-">
                        <a class="nav-link dropdown-toggle" [routerLink]="['/kingdom-farm-component']" routerLinkActive="router-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ourBusiness}}</a>
                        <div class="dropdown-menu dropdown-menu-center" aria-labelledby="navbarDropdown">
                            <a class="nav-link" [routerLink]="['/kingdom-farm-component']" routerLinkActive="router-link" href="#">ธุรกิจปศุสัตว์</a>
                            <!-- <a class="nav-link" [routerLink]="['/kingdom-feedmills-component']" routerLinkActive="router-link" href="#">ธุรกิจอาหารสัตว์</a> -->
                        </div>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/newsandevents-component']" routerLinkActive="router-link" href="#">{{newsAndEvent}}</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/article-item-component']" routerLinkActive="router-link" href="#">สาระน่ารู้</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/workwithus-component']" routerLinkActive="router-link" href="#">{{workwithus}}</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/contactus-component']" routerLinkActive="router-link" href="#">{{contactUs}}</a>
                    </li>

                    <!-- <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/testarea-component']" routerLinkActive="router-link" href="#">{{test}}</a>
                    </li> -->

                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/login']" routerLinkActive="router-link" href="#" >
                            <i *ngIf="isLoggedIn" class="fa fa-sign-out fa-1x" aria-hidden="true" (click)="logout()"  title="Log out"></i>
                            <i *ngIf="!isLoggedIn" class="fa fa-sign-in fa-1x" aria-hidden="true"  title="Log in"></i>
                        </a>
                    </li>

                    <div *ngIf="role1">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="servicesDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{systems}}</a>
                            <div class="dropdown-menu dropdown-menu-left " aria-labelledby="servicesDropdown">
                                <div class="d-md-flex ">
                                    <div>
                                        <!-- <a class="dropdown-item" (click)="verifyUser(true)">ADMIN</a>
                                        <a class="dropdown-item" (click)="verifyUser(false)">USER</a> -->
                                        <a class="dropdown-item" [routerLink]="['/app-goods-popup-component']" routerLinkActive="router-link">{{goodsView}}</a>
                                        <a class="dropdown-item" [routerLink]="['/testarea-component']" routerLinkActive="router-link">{{test}}</a>
                                        <a class="dropdown-item" [routerLink]="['/testarea2-component']" routerLinkActive="router-link">{{test2}}</a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>
                </ul>

                <!-- <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" href="/">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/contact">Contact</a>
                    </li>
                </ul>
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">Account</a>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" href="/login">Login</a></li>
                            <li><a class="dropdown-item" href="/register">Register</a></li>
                        </ul>
                    </li>
                </ul> -->
            </div>
        </div>
    </nav>
 </body>
</html>